import { unionBy } from 'lodash';
import {
    FETCH_RECOGNIZED_SENDERS_REQUEST,
    FETCH_RECOGNIZED_SENDERS_SUCCESS,
    FETCH_RECOGNIZED_SENDERS_FAILURE,
    UPDATE_RECOGNIZED_SENDERS_REQUEST,
    UPDATE_RECOGNIZED_SENDERS_SUCCESS,
    UPDATE_RECOGNIZED_SENDERS_FAILURE,
    UNVERIFIED_ALL_DOMAINS_FOR_SENDER
} from './types/recognized-senders-action-types';

import { refreshAggResults } from './aggregate-results-action-creators';
import { openUnverifiedSenderWarningSnackbar } from './snackbar-action-creators';

import { aggDataBySenderIdSelector } from '../selectors/aggregate-results-selectors';
import { domainsForARecognizedSender } from '../../sender-verification/sender-verification-selectors';

import MimirService from '../services/mimir-service';

function fetchRecognizedSendersRequest(){
    return {
        type: FETCH_RECOGNIZED_SENDERS_REQUEST,
    };
}

function fetchRecognizedSendersSuccess( { byId }, { domain, senderId } ){
    return {
        byId,
        domain,
        senderId,
        type: FETCH_RECOGNIZED_SENDERS_SUCCESS,
    };
}

function fetchRecognizedSendersFailure( error ){
    return {
        error,
        type: FETCH_RECOGNIZED_SENDERS_FAILURE,
    };
}

function fetchRecognizedSenders( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        const { domain, domainGroupId, status, senderId } = params;
        dispatch( fetchRecognizedSendersRequest() );

        const api = new MimirService( DATA_API );

        return api.getRecognizedSenders( domain, senderId, domainGroupId, status ).then(
            ( response ) => dispatch( fetchRecognizedSendersSuccess( response, params ) ),
            ( error ) => dispatch( fetchRecognizedSendersFailure( error ) )
        );
    };
}

export function fetchRecognizedSendersByDomain( domain ){
    return ( dispatch ) => dispatch( fetchRecognizedSenders( { domain } ) );
}

export function fetchDomainsByRecognizedSender( senderId ){
    return ( dispatch ) => dispatch( fetchRecognizedSenders( { senderId } ) );
}

function updateRecognizedSendersRequest(){
    return {
        type: UPDATE_RECOGNIZED_SENDERS_REQUEST,
    };
}

function updateRecognizedSendersSuccess( { byId }, domain, senderId ){
    return {
        byId,
        domain,
        senderId,
        type: UPDATE_RECOGNIZED_SENDERS_SUCCESS,
    };
}

function updateRecognizedSendersFailure( error ){
    return {
        error,
        type: UPDATE_RECOGNIZED_SENDERS_FAILURE,
    };
}

function unverifiedAllDomainsForSender(){
    return {
        type: UNVERIFIED_ALL_DOMAINS_FOR_SENDER
    };
}

function updateRecognizedSenders( { data, domain, senderId } ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( updateRecognizedSendersRequest() );

        const api = new MimirService( DATA_API );

        return api.updateRecognizedSenders( domain, data )
            .then(
                ( response ) => dispatch( updateRecognizedSendersSuccess( response, domain, senderId ) ),
                ( error ) => dispatch( updateRecognizedSendersFailure( error ) )
            )
            .then( () => dispatch( refreshAggResults() ) );
    };
}

export function updateRecognizedSendersForADomain( domain, updatedSenders ){
    const data = updatedSenders.map( sender => ( { ...sender, domain } ) );

    return ( dispatch ) => {
        return dispatch( updateRecognizedSenders( { data, domain } ) );
    };
}

export function updateDomainsForARecognizedSender( senderId, updatedDomains ){
    return ( dispatch, getState ) => {
        const state = getState();
        const originalRecognizedDomains = domainsForARecognizedSender( state ).map( domain => {
            return {
                domain: domain.domain,
                status: domain.status
            };
        } );

        // order matters in unionBy b/c result values chosen from first array
        const mergedResults = unionBy( updatedDomains, originalRecognizedDomains, 'domain' );
        const allStatuses = mergedResults.map( domain => domain.status );

        // if merged result doesn't include any `status: accepted`, we know the sender has been unverified for all its domains
        if( !allStatuses.includes( 'accepted' ) ){
            const senderName = aggDataBySenderIdSelector( state )[senderId].name;

            dispatch( unverifiedAllDomainsForSender() );
            dispatch( openUnverifiedSenderWarningSnackbar( senderName ) );
        }

        const data = updatedDomains.map( domain => ( { ...domain, senderId } ) );

        return dispatch( updateRecognizedSenders( { data, senderId } ) );
    };
}
